var map = {
	"./Construction/Apartments/apartments.jpg": 4095,
	"./Construction/Apartments/p1.jpg": 8551,
	"./Construction/Apartments/p2.jpg": 3800,
	"./Construction/Apartments/p3.jpg": 7317,
	"./Construction/Apartments/p4.jpg": 2318,
	"./Construction/construcion-default.jpg": 963,
	"./import_export/Pulses/p1.jpg": 2851,
	"./import_export/Pulses/p2.jpg": 1044,
	"./import_export/Pulses/p3.jpg": 9569,
	"./import_export/Rice/p1.jpg": 2596,
	"./import_export/Rice/p2.jpg": 4403,
	"./import_export/Rice/p3.jpg": 3350,
	"./import_export/Rice/p4.jpg": 6701,
	"./import_export/Rice/p5.jpg": 3248,
	"./import_export/fish/fish.jpg": 5984,
	"./import_export/fish/p1.jpg": 3487,
	"./import_export/fish/p2.jpg": 9152,
	"./import_export/fish/p3.jpg": 3725,
	"./import_export/fish/p4.jpg": 2278,
	"./import_export/fish/p5.jpg": 803,
	"./import_export/fish/p6.jpg": 6324,
	"./import_export/fruits/fruits.jpg": 3954,
	"./import_export/fruits/p1.jpg": 3986,
	"./import_export/fruits/p2.jpg": 9917,
	"./import_export/fruits/p3.jpg": 7696,
	"./import_export/fruits/p4.jpg": 3971,
	"./import_export/fruits/p5.jpg": 838,
	"./import_export/fruits/p6.jpg": 8593,
	"./import_export/fruits/p7.jpg": 4260,
	"./import_export/fruits/p8.jpg": 3319,
	"./import_export/hvhgv.jpg": 306,
	"./import_export/import-export-default.jpg": 3413,
	"./import_export/spices/p1.jpg": 2670,
	"./import_export/spices/p2.jpg": 6377,
	"./import_export/spices/p3.jpg": 1004,
	"./import_export/spices/p4.jpg": 5351,
	"./import_export/spices/p5.jpg": 4538,
	"./import_export/spices/p6.jpg": 7141,
	"./import_export/spices/p7.jpg": 4776,
	"./import_export/spices/p8.jpg": 9267,
	"./import_export/spices/spices.jpg": 9874,
	"./import_export/vegetable/p1.jpg": 2362,
	"./import_export/vegetable/p10.jpg": 2248,
	"./import_export/vegetable/p11.jpg": 9861,
	"./import_export/vegetable/p12.jpg": 2634,
	"./import_export/vegetable/p2.jpg": 6501,
	"./import_export/vegetable/p3.jpg": 1672,
	"./import_export/vegetable/p4.jpg": 5275,
	"./import_export/vegetable/p5.jpg": 9438,
	"./import_export/vegetable/p6.jpg": 8105,
	"./import_export/vegetable/p7.jpg": 3756,
	"./import_export/vegetable/p8.jpg": 7855,
	"./import_export/vegetable/p9.jpg": 5186,
	"./import_export/vegetable/vegetables.jpg": 4231
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5654;